import { render, staticRenderFns } from "./selectContacts.vue?vue&type=template&id=2967b84a&"
import script from "./selectContacts.vue?vue&type=script&lang=js&"
export * from "./selectContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports